module.exports = __webpack_public_path__ + "images/favicon-32x32-4dc7e02eaf581d4892f2ca0a51702d6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/favicons/favicon-32x32.png
// module id = ./src/images/favicons/favicon-32x32.png
// module chunks = 1